/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import { PRODUCT_NAME } from '@/constants';
import classes from './index.module.css';
import ProductCard from './ProductCard';
import useProductsContext from '../../hooks/useProductsContext';
import useConnectionContext from '../../hooks/useConnectionContext';
import { popupCenter } from '../../utils';
import 'react-loading-skeleton/dist/skeleton.css';

const {
  RETURN_ASSURANCE, SHIPPING_PROTECTION, GREEN_SHIPPING_PROTECTION, BUYBACK_GUARANTEE, EXTENDED_WARRANTY, DELIVERY_GUARANTEE,
} = PRODUCT_NAME;

const hrefMap = {
  [RETURN_ASSURANCE]: '/ra/application/intro',
  [SHIPPING_PROTECTION]: '/bp/application',
  [GREEN_SHIPPING_PROTECTION]: '/bp/application',
  [DELIVERY_GUARANTEE]: '/bp/application',
  [BUYBACK_GUARANTEE]: '/bg/application',
  [EXTENDED_WARRANTY]: '/ew/application',
};
function ProductSkeleton({ isLoading }) {
  const activeProducts = new Array(4).fill(0);
  return (
    <div className={classes.wrapper}>
      <div className={classes.content}>
        <div className={classes.products_title}>
          <Skeleton containerClassName={classes.products_title} style={{ height: '100%', width: '200PX' }} />
        </div>
        <div className={classes.products_container}>
          {
            activeProducts.map((_, index) => (
              <ProductCard
                key={index}
                isLoading={isLoading}
              />
            ))
          }
        </div>
      </div>
    </div>
  );
}

export default function Products() {
  const {
    productsGallery, galleryLoading,
  } = useProductsContext();
  const { store, payment: { connected } = {} } = useConnectionContext();
  const navigate = useNavigate();
  const clickHandler = (authorized, href, insuranceName) => {
    if (authorized || [BUYBACK_GUARANTEE, EXTENDED_WARRANTY].includes(insuranceName)) {
      navigate(href);
      return;
    }
    if (authorized) {
      window.open('https://ntcchgwtg0g.typeform.com/to/EdBu9IDK');
    } else {
      popupCenter({
        url: `https://${process.env.SHOPIFY_APP_INSALLATION_URI}?shop=${store.info}`, title: '', w: 800, h: 600,
      });
    }
  };
  if (galleryLoading) {
    return (
      <ProductSkeleton isLoading={galleryLoading} />
    );
  }
  const activeProducts = productsGallery.filter((item) => item.involvedStatus === 'active') || [];
  const availableProducts = productsGallery.filter((item) => item.status === 'live' && item.involvedStatus !== 'active') || [];
  const unAvailableProducts = productsGallery.filter((item) => item.status === 'coming soon') || [];
  return (
    <div className={classes.wrapper}>
      {!!activeProducts.length && (
        <div className={classes.content}>
          <div className={classes.products_title}>Active products</div>
          <div className={classes.products_container}>
            {
              activeProducts.map((product) => {
                const {
                  insuranceName, authorized, insuranceDescription, insuranceId, involvedStatus, learnMore, settingsHref,
                } = product;

                // const bottomButton = insuranceName === RETURN_ASSURANCE
                //   ? <Link to="/ra/settings" className={classes.product_button_setting}>{'Settings >'}</Link>
                //   : <span className={classes.product_button_disabled}>{'Settings >'}</span>;
                let bottomButton = settingsHref ? <Link to={settingsHref} className={classes.product_button_setting}>{'Settings >'}</Link> : null;
                if (store.name !== 'Shopify' && insuranceName !== RETURN_ASSURANCE) {
                  bottomButton = <span className={classes.product_button_disabled}>{'Settings >'}</span>;
                }
                return (
                  <ProductCard
                    key={insuranceName}
                    authorized={authorized}
                    title={insuranceName}
                    brief={insuranceDescription}
                    involvedStatus={involvedStatus}
                    id={insuranceId}
                    store={store}
                    footer={bottomButton}
                    learnMore={learnMore}
                    isLoading={galleryLoading}
                  />
                );
              })
            }
          </div>
        </div>
      )}
      {!!availableProducts.length && (
        <div className={classes.content}>
          <div className={classes.products_title}>Available products</div>
          <div className={classes.products_container}>
            {
              availableProducts.map((product) => {
                const {
                  insuranceName, authorized, involvedStatus, learnMore,
                } = product;
                let isShowEnable = false;
                if (!['pending', 'inactive', 'active'].includes(involvedStatus)) {
                  isShowEnable = true;
                }
                if (insuranceName.indexOf('Protection') > -1 && !connected) {
                  isShowEnable = false;
                }
                // 只有bp产品才会提示商家去绑卡
                const isShowBPTips = !isShowEnable && !connected && (insuranceName.indexOf('Protection') > -1 || insuranceName === PRODUCT_NAME.DELIVERY_GUARANTEE);

                const bottomButton = (
                  <>
                    <Button
                      variant="contained"
                      // onClick={handleSave}
                      sx={{
                        backgroundColor: '#645AFF',
                        height: '36px',
                        textTransform: 'none',
                        '&:hover': {
                          backgroundColor: '#5950DF',
                        },
                        '&.Mui-disabled': {
                          background: 'rgba(0,0,0,.04)',
                          color: 'rgba(0,0,0,.25)',
                          cursor: 'not-allowed',
                          border: '1px solid #d9d9d9',
                        },
                      }}
                      onClick={() => isShowEnable && clickHandler(authorized, hrefMap[insuranceName], insuranceName)}
                      disabled={!isShowEnable}
                    >
                      {[BUYBACK_GUARANTEE, EXTENDED_WARRANTY].includes(insuranceName) ? 'Apply >' : ' Enable >'}
                    </Button>
                    {isShowBPTips && (
                      <span className={classes.no_bank_tip}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_13727_50384)">
                            <path fillRule="evenodd" clipRule="evenodd" d="M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM7.2 4.8C7.2 4.35817 7.55817 4 8 4C8.44183 4 8.8 4.35817 8.8 4.8V8C8.8 8.44183 8.44183 8.8 8 8.8C7.55817 8.8 7.2 8.44183 7.2 8V4.8ZM8 12C8.44183 12 8.8 11.6418 8.8 11.2C8.8 10.7582 8.44183 10.4 8 10.4C7.55817 10.4 7.2 10.7582 7.2 11.2C7.2 11.6418 7.55817 12 8 12Z" fill="#B98900" />
                          </g>
                          <defs>
                            <clipPath id="clip0_13727_50384">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        Set payment method before enabling it.
                      </span>
                    )}
                  </>
                );

                return (
                  <ProductCard
                    key={insuranceName}
                    authorized={authorized}
                    title={product.insuranceName}
                    brief={product.insuranceDescription}
                    status={product.status}
                    id={product.insuranceId}
                    involvedStatus={involvedStatus}
                    store={store}
                    footer={bottomButton}
                    learnMore={learnMore}
                  />
                );
              })
            }
          </div>
        </div>
      )}
      {
        !!unAvailableProducts.length && (
          <div className={classes.content}>
            <div className={classes.products_title}>Unavailable products</div>
            <div className={classes.products_container}>
              {
                unAvailableProducts.map((product) => {
                  const bottomButton = (
                    <span className={classes.coming_soon}>Coming soon</span>
                  );
                  return (
                    <ProductCard
                      key={product.insuranceName}
                      title={product.insuranceName}
                      brief={product.insuranceDescription}
                      status={product.status}
                      id={product.insuranceId}
                      learnMore={product.learnMore}
                      store={store}
                      footer={bottomButton}
                    />
                  );
                })
              }
            </div>
          </div>
        )
      }

    </div>
  );
}
